<template>
  <div class="" id="pageTop" style="padding:1rem 1rem 10rem">
    <div class="">
      <div class="col-12">
        <div class="row">
            
            <div class="col-12">
                <h5 class="my-3">My Registrations</h5>
            </div>
            <div class="col-12 my-1" align="left">
                <button class="btn btn-lg btn-primary" data-toggle="modal" data-target="#modalEvents" >
                    <i class="fas fa-plus mr-3"></i> Add new registration
                </button>
            </div>
			<div class="col-12 my-2">
                <div class="alert alert-info">
                    The list below shows all current registrations under your profile.
                </div>
            </div>
            <div class="col-12 my-4 text-muted" align="center" v-if="!Array.isArray(userBookings)">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="col-12 my-4 text-muted" align="center" v-if="Array.isArray(userBookings) && userBookings.length<1">
              <em>No registrations found... </em>
            </div>
            <div class="col-12 my-3" v-if="Array.isArray(userBookings) && userBookings.length>0">
                <ul class="list-group">
                  <li class="list-group-item d-none d-md-block bg-light">
                    <div class="row">
                      <div class="col-12 col-md-3">
                        <strong>Registration ID</strong>
                      </div>
                      <div class="col-12 col-md-6">
                        <strong>Details</strong>
                      </div>
                      <div class="col-12 col-md-3">
                        <strong>Actions</strong>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item" v-for="booking in userBookings" :key="booking.id">
                    <div class="row">
                      <div class="col-12 col-md-3">
                        {{booking.data.orderid}}
                      </div>
                      <div class="col-12 col-md-6 mb-2">
                        {{booking.data.fname}} {{booking.data.lname}} - 
                        {{booking.data.confticket}}
                        <br/><em class="small">{{booking.data.confeventname}}</em>
                        
                      </div>
                      <div class="col-12 col-md-3 ">
                        <div class="dropdown">
                          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Please choose
                          </button>
                          <div class="dropdown-menu col-12" aria-labelledby="dropdownMenuButton">
                            <button class="dropdown-item" @click="$router.push(`/registrations/view/${booking.id}`)" >View/Print registration</button>
							<div class="dropdown-divider"></div>
							<button class="dropdown-item pointer" data-toggle="modal" data-target="#vaxxActionModal" @click="orderData=booking; componentKey=Math.floor(Date.now()/1000); modalTitle='Upload Vaccination Card'">Upload vaccination card</button>
                            <div class="dropdown-divider" v-if="booking.data.status!='PAID'"></div>
                            <button class="dropdown-item pointer" data-toggle="modal" data-target="#payActionModal" @click="orderData=booking; componentKey=Math.floor(Date.now()/1000); modalTitle='Make Payment'" v-if="booking.data.status!='PAID'">Add payment</button>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item pointer" data-toggle="modal" data-target="#registrationActionModal" @click="modalTitle='Update Hotel Information'; orderData=booking; componentKey=Math.floor(Date.now()/1000)">Update flight and hotel information</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
            </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
		<div class="modal fade" id="registrationActionModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title mkt-title" >{{modalTitle}}</h4>
						<button type="button" id="btnCloseProfileModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding:1rem 3rem">
						<div class="row">
							<div class="col-12">
								<FlightHotelForm :orderData="orderData" :key="componentKey" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="vaxxActionModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title mkt-title" >{{modalTitle}}</h4>
						<button type="button" id="btnCloseVaxxModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding:1rem 3rem">
						<div class="row">
							<div class="col-12">
								<VaxxForm :orderData="orderData" :key="componentKey" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="payActionModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title mkt-title" >{{modalTitle}}</h4>
						<button type="button" id="btnClosePayModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding:1rem 3rem">
						<div class="row">
							<div class="col-12">
								<PaymentForm :orderData="orderData" :key="componentKey" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


    <div class="modal fade" id="modalEvents" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Choose Event</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="list-group">
              <li class="list-group-item pointer" data-dismiss="modal" @click="$router.push(`/${conf.id}/registrations/add`)" v-for="conf in confList" :key="conf.id">
                  {{conf.data.confname}}
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlightHotelForm from '../components/FlightHotelForm.vue'
import VaxxForm from '../components/VaxxForm.vue'
import PaymentForm from '../components/PaymentForm.vue'
export default {
  name: 'Registration',
  components: {
    FlightHotelForm, VaxxForm, PaymentForm
  },
  computed:{
    userProfile(){
        return this.$store.state.userProfile
    },
    userBookings(){
      return this.$store.state.userBookings
    },
    confList(){
      return this.$store.state.confList
    },
  },
  data(){
    return{
		modalTitle: '',
		eventId: "",
		orderData: "",
		componentKey: "",
    }
  },
  methods:{

  },
  mounted(){
    
  },
}
</script>
